/* import { obtenerMesesAnteriores } from "shared/utils"
import { EntidadAuditable } from "shared/entidad/domain/entidadAuditable"
import { Actividad } from "pages/reportes/shared/domain/Actividad"
import { OperacionCredito } from "pages/reportes/shared/domain/OperacionCredito"
import { Establecimiento } from "pages/reportes/shared/domain/Establecimiento"
import { ItemHistorialCrediticio } from "pages/reportes/shared/domain/ItemHistorialCrediticio"
import { ItemConsultasCliente } from "pages/reportes/shared/domain/ItemConsultasCliente"
import { ItemMorosidad } from "pages/reportes/shared/domain/ItemMorosidad"
import { ItemVencimiento } from "pages/reportes/shared/domain/ItemVencimiento"
import { ItemOperacionCancelada } from "pages/reportes/shared/domain/ItemOperacionCancelada"
import { ItemSeguro } from "pages/reportes/shared/domain/ItemSeguro"
import { ItemSaldoPorVencer } from "pages/reportes/shared/domain/ItemSaldoPorVencer" */
import { obtenerMesesAnteriores } from "@/shared/utils";
import { Actividad } from "./Actividad";
import { ItemConsultasCliente } from "./ItemConsultasCliente";
import { ItemHistorialCrediticio } from "./ItemHistorialCrediticio";
import { ItemMorosidad } from "./ItemMorosidad";
import { ItemOperacionCancelada } from "./ItemOperacionCancelada";
import { ItemSaldoPorVencer } from "./ItemSaldoPorVencer";
import { ItemSeguro } from "./ItemSeguro";
import { ItemVencimiento } from "./ItemVencimiento";
import * as moment from "moment";
export class EjemploReporte {
    tipo_reporte;
    identificacion_cliente;
    nombres_cliente;
    razon_social;
    edad_cliente;
    celular_cliente;
    correo_cliente;
    direccion_cliente;
    ruc_cliente;
    tipo_contribuyente;
    clase_contribuyente;
    fecha_inicio_actividades;
    fecha_actualización;
    fecha_cese_actividades;
    fecha_reinicio_actividades;
    cuota_mensual;
    usuario;
    historial_crediticio_desde;
    //
    tiene_consultas;
    tiene_informacion_laboral;
    tiene_historial;
    tiene_establecimientos;
    tiene_resumen;
    tiene_puntuaciones;
    tiene_resumen_morosidades;
    tiene_operaciones_credito_bancarias;
    tiene_operaciones_credito_comerciales;
    tiene_cuota_mensual;
    tiene_resumen_vencimientos;
    tiene_saldos_por_vencer;
    tiene_operaciones_canceladas;
    tiene_informacion_seguros;
    tiene_ruc;
    // informacion laboral
    ruc_empleador;
    tipo_empresa;
    nombre_empresa;
    codigo_sucursal;
    telefono_sucursal;
    direccion_sucursal;
    fax_sucursal;
    direccion_afiliado;
    telefono_afiliado;
    ocupacion_afiliado;
    celular_afiliado;
    email_afiliado;
    salario_afiliado;
    fecha_ingreso;
    fecha_salida;
    ubicacion_empresa;
    // resumen
    saldo_impagos;
    total_impagos;
    saldo_demanda_judicial;
    total_demanda_judicial;
    saldo_cartera_castigada;
    total_cartera_castigada;
    // estados
    estado_contribuyente;
    obligado_llevar_contabilidad;
    beneficiado_333;
    // listados
    actividadesEconomicas;
    operacionesCreditoBancarias;
    operacionesCreditoComerciales;
    saldosPorVencer;
    establecimientos;
    historialCrediticio;
    consultasCliente;
    morosidades;
    vencimientos;
    operacionesCanceladas;
    seguros;
    // graficas
    score_crediticio;
    score_sobreendeudamiento;
    constructor() {
        this.tipo_reporte = "NORMAL";
        this.identificacion_cliente = null;
        this.nombres_cliente = null;
        this.razon_social = null;
        this.edad_cliente = 0;
        this.celular_cliente = null;
        this.correo_cliente = null;
        this.direccion_cliente = null;
        this.ruc_cliente = null;
        this.tipo_contribuyente = null;
        this.clase_contribuyente = null;
        this.fecha_inicio_actividades = null;
        this.fecha_actualización = null;
        this.fecha_cese_actividades = null;
        this.fecha_reinicio_actividades = null;
        //
        this.tiene_consultas = true;
        this.tiene_informacion_laboral = true;
        this.tiene_historial = true;
        this.tiene_establecimientos = true;
        this.tiene_resumen = true;
        this.tiene_puntuaciones = true;
        this.tiene_resumen_morosidades = true;
        this.tiene_operaciones_credito_bancarias = true;
        this.tiene_operaciones_credito_comerciales = true;
        this.tiene_cuota_mensual = true;
        this.tiene_resumen_vencimientos = true;
        this.tiene_saldos_por_vencer = true;
        this.tiene_operaciones_canceladas = true;
        this.tiene_informacion_seguros = true;
        this.tiene_ruc = true;
        //
        this.cuota_mensual = 0;
        this.usuario = null;
        this.historial_crediticio_desde = null;
        // informacion laboral
        this.ruc_empleador = null;
        this.tipo_empresa = null;
        this.nombre_empresa = null;
        this.codigo_sucursal = null;
        this.telefono_sucursal = null;
        this.direccion_sucursal = null;
        this.fax_sucursal = null;
        this.direccion_afiliado = null;
        this.telefono_afiliado = null;
        this.ocupacion_afiliado = null;
        this.celular_afiliado = null;
        this.email_afiliado = null;
        this.salario_afiliado = null;
        this.fecha_ingreso = null;
        this.fecha_salida = null;
        this.ubicacion_empresa = null;
        // resumen
        this.saldo_impagos = 0;
        this.total_impagos = 0;
        this.saldo_demanda_judicial = 0;
        this.total_demanda_judicial = 0;
        this.saldo_cartera_castigada = 0;
        this.total_cartera_castigada = 0;
        // estados
        this.estado_contribuyente = true;
        this.obligado_llevar_contabilidad = true;
        this.beneficiado_333 = true;
        // listados
        this.actividadesEconomicas = [new Actividad()];
        this.establecimientos = [];
        this.operacionesCreditoBancarias = [];
        this.operacionesCreditoComerciales = [];
        this.saldosPorVencer = [new ItemSaldoPorVencer()];
        this.operacionesCanceladas = [new ItemOperacionCancelada()];
        this.historialCrediticio = this.inicializarHistorialCrediticio();
        this.consultasCliente = this.inicializarConsultasCliente();
        this.morosidades = this.inicializarResumenMorosidades();
        this.vencimientos = this.inicializarResumenVencimientos();
        this.seguros = this.inicializarInformacionSeguros();
        this.score_crediticio = 999;
        this.score_sobreendeudamiento = 999;
    }
    inicializarHistorialCrediticio() {
        const listado = [];
        const CANTIDAD_MESES = 36;
        const meses = obtenerMesesAnteriores(moment(), CANTIDAD_MESES);
        meses.forEach((mes) => {
            const item = new ItemHistorialCrediticio();
            item.mes = mes;
            listado.push(item);
        });
        return listado;
    }
    inicializarConsultasCliente() {
        const listado = [];
        const CANTIDAD_MESES = 12;
        const meses = obtenerMesesAnteriores(moment(), CANTIDAD_MESES);
        meses.forEach((mes) => {
            const item = new ItemConsultasCliente();
            item.mes = mes;
            listado.push(item);
        });
        return listado;
    }
    inicializarResumenMorosidades() {
        const listado = [];
        const acreedores = [
            "Sistema Financiero Regulado SB",
            "Entidades Reguladas SEPS",
            "Sector Comercial (INFOCOM)",
            "Total",
        ];
        acreedores.forEach((acreedor) => {
            const item = new ItemMorosidad();
            item.acreedor = acreedor;
            listado.push(item);
        });
        return listado;
    }
    inicializarResumenVencimientos() {
        const listado = [];
        const acreedores = [
            "Marcimex - telf: 072831991",
            "Marcimex - telf: 072831991",
            "ALFANET - telf: 023731070",
            "Total",
        ];
        acreedores.forEach((acreedor) => {
            const item = new ItemVencimiento();
            item.acreedor = acreedor;
            listado.push(item);
        });
        return listado;
    }
    inicializarInformacionSeguros() {
        const listado = [];
        const seguros = ["IESS", "ISSFA", "ISSPOL"];
        seguros.forEach((seguro) => {
            const item = new ItemSeguro();
            item.seguro = seguro;
            listado.push(item);
        });
        return listado;
    }
}
